import React, {useEffect, useRef, useState} from 'react';
import {StyleSheet, View} from 'react-native';
import {isWeb, windowWidth} from '../../constants';
import {useDispatch, useSelector} from 'react-redux';
import {showSheet} from '../../actions/SheetActions';
import {selectrootsheettype} from '../../selectors/SheetSelector';
import CustomBottomSheet from '../bottom-sheet';
import {CustomText} from '../text/Text';
import {useTranslation} from 'react-i18next';
import {Shadow} from 'react-native-shadow-2';
import SVG from '../../imports/svg';
import EmptyBox from '../empty-box/EmptyBox.component';
import Button from '../button/Button.componet';
import { useHistory } from '../../imports/Router';
import { selectvehicleslisttype } from '../../selectors/vehicleslist';
import { selecetusertype } from '../../selectors/User';

const PurchasePackageError = () => {
  const dispatch = useDispatch();
  const bottomSheetRef = useRef(null);
  const history = useHistory()
  const {sheetId } = useSelector(state =>
    selectrootsheettype(state),
  );
  const { hasTrip  } = useSelector((state)=>selecetusertype(state))
  const {t} = useTranslation();

  function closeHandler() {
    switch (isWeb) {
      case true:
        bottomSheetRef?.current?.snapTo(() => 0);
        break;
      case false:
        setTimeout(()=>{
          dispatch(showSheet({sheetId: ''}));
        },400)
        bottomSheetRef.current?.close();
        break;
      default:
        break;
    }
  }

  useEffect(() => {
    switch (sheetId) {
      case 'purchasePackageError':
        openHandler();
        break;
      default:
        closeHandler();
        break;
    }
  }, [sheetId]);

  function openHandler() {
    if (isWeb) return;
    bottomSheetRef.current?.expand();
  }

  const realizedPress=()=>{
    if ( hasTrip ) {
      closeHandler()
    }else {
      history.push('/payment')
      closeHandler()
    }
  }

  return (
    <CustomBottomSheet
      onClose={closeHandler}
      ref={bottomSheetRef}
      enablePanDownToClose={isWeb ? undefined : true}
      snapPoints={isWeb ? ({minHeight}) => [1, minHeight] : [295]}
      defaultSnap={isWeb ? 486 : undefined}
      onSpringEnd={
        isWeb
          ? () => {
              if (bottomSheetRef?.current?.height < 2) {
                dispatch(showSheet({sheetId: ''}));
              }
            }
          : undefined
      }
      open={true}
      isScrollView={isWeb ? undefined : true}
      scrollViewStyle={isWeb ? undefined : styles.scroll}>
      <View style={styles.content}>
        <View>
          <EmptyBox height={18} />
          <Shadow
            offset={[0, 0]}
            containerStyle={styles.shadow}
            distance={6}>
            <View style={styles.shadowContainer}>
              <SVG name={'endTripError'} width={44} height={44} />
            </View>
          </Shadow>
          <CustomText
            mt={12}
            txtAlign="center"
            size={18}
            font={'700'}
            color={'#2D2D2D'}>
            {hasTrip ? t('your_are_in_travel') : t('unpaid_trip')}
          </CustomText>
          <CustomText
            mt={12}
            txtAlign="center"
            size={15}
            style={styles.descText}
            font={'500'}
            color={'#5A5A5A'}>
            {hasTrip ? t('in_middle_of_trip_you_cant_buy_new_package') : t('when_your_previous_trip_isnt_paid_you_cant_buy_new_package')}
          </CustomText>
        </View>
        <Button onPress={realizedPress} style={styles.button}>
          <CustomText color={'#fff'} size={18} font={'500'}>
            {t('i_realized')}
          </CustomText>
        </Button>
      </View>
    </CustomBottomSheet>
  );
};

export default PurchasePackageError;

const styles = StyleSheet.create({
  descText: {
    width: windowWidth * 0.7,
  },
  shadow  : {
      width: 64,
      height: 64,
      justifyContent: 'center',
      alignSelf  :'center' , 
      alignItems: 'center',
  },
  content: {
    width: '100%',
    height: 295,
    alignItems: 'center',
    justifyContent : 'space-between' , 
    alignItems : 'center' , 
  },
  button: {
    width: windowWidth * 0.91,
    marginBottom : 40 , 
    height: 40,
    backgroundColor: '#303261',
  },
  shadowContainer: {
    width: 64,
    height: 64,
    borderRadius: 100,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff',
  },
  crossContainer: {},
  scroll: {
    flex: 1,
  },
});
